<div myPreloader class="preloaderbar hide"><span class="bar"></span></div>
<router-outlet></router-outlet>